import type { FC } from 'react';
import { Contract } from '../types';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

interface Props {
  contracts: Contract[];
  onSelect: (contract: Contract) => void;
  onDelete: (id: string) => void;
}

const ContractList: FC<Props> = ({ contracts, onSelect, onDelete }) => {
  const getStatusClass = (status: Contract['status']) => `status-badge status-${status}`;
  
  const getStatusText = (status: Contract['status']) => {
    const statuses = {
      draft: 'Черновик',
      active: 'Активен',
      completed: 'Выполнен',
      overdue: 'Просрочен',
      cancelled: 'Отменён'
    };
    return statuses[status];
  };

  const sortedContracts = [...contracts].sort((a, b) => 
    new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  if (contracts.length === 0) {
    return (
      <div className="empty-state">
        <p>📭 У вас пока нет контрактов</p>
        <p className="hint">Создайте первый контракт!</p>
      </div>
    );
  }

  return (
    <div className="contract-list">
      {sortedContracts.map(contract => (
        <div 
          key={contract.id} 
          className="contract-card"
          onClick={() => onSelect(contract)}
        >
          <div className="contract-header">
            <h3>{contract.title}</h3>
            <span className={getStatusClass(contract.status)}>
              {getStatusText(contract.status)}
            </span>
          </div>
          
          <p className="contract-description">{contract.description}</p>
          
          <div className="contract-meta">
            <span className="deadline">
              📅 {format(new Date(contract.deadline), 'dd MMM yyyy', { locale: ru })}
            </span>
            
            {contract.reward && (
              <span className="reward">🏆 {contract.reward}</span>
            )}
            
            {contract.penalty && contract.status === 'overdue' && (
              <span className="penalty">⚠️ Штраф: {contract.penalty}</span>
            )}
          </div>
          
          <div className="contract-footer">
            <span className="creator">
              {contract.creator === 'alex' ? '👤 Alex' : '🤖 Cody'}
            </span>
            <button 
              className="btn-delete"
              onClick={(e) => {
                e.stopPropagation();
                if (confirm('Удалить контракт?')) {
                  onDelete(contract.id);
                }
              }}
            >
              🗑️
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContractList;
